import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs';
import { ToastService } from '../services/toast.service';

let ultimoAviso = '';
let ultimoAvisoAt = 0;

/**
 * El servidor respondió, pero el plan recortó lo pedido (por ejemplo, el historial de
 * un informe) y lo dice en la cabecera X-Plan-Aviso. Se muestra una vez: una pantalla
 * que pide varios informes juntos no tiene que repetir el mismo cartel.
 */
export const planAvisoInterceptor: HttpInterceptorFn = (req, next) => {
  const toast = inject(ToastService);

  return next(req).pipe(
    tap(evento => {
      if (!(evento instanceof HttpResponse)) return;
      const cabecera = evento.headers.get('X-Plan-Aviso');
      if (!cabecera) return;

      const aviso = decodeURIComponent(cabecera);
      if (aviso === ultimoAviso && Date.now() - ultimoAvisoAt < 60_000) return;

      ultimoAviso = aviso;
      ultimoAvisoAt = Date.now();
      toast.info(aviso);
    }),
  );
};
